module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid section"
  }, [_c('div', {
    staticClass: "row heading"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-9 text-right"
  }, [_c('div', {
    staticStyle: {
      "width": "250px",
      "display": "inline-block"
    }
  }, [_c('show-hide-cols', {
    attrs: {
      "cols": _vm.cols,
      "selected": _vm.filters.columns
    }
  })], 1), _vm._v(" "), _c('save-report'), _vm._v(" "), _c('save-chart', {
    attrs: {
      "xOpts": _vm.cols,
      "yOpts": _vm.cols,
      "fn": "accountCashflow2",
      "filters": _vm.filters
    }
  }), _vm._v(" "), _c('download', {
    attrs: {
      "fn": "accountCashflow2",
      "filters": _vm.filters,
      "cols": _vm.cols
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-light",
    on: {
      "click": _vm.clearFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v("  Clear Filters")]), _vm._v(" \n\n\n              \n            "), _c('paginate', {
    attrs: {
      "page-count": _vm.num_pages,
      "initial-page": parseInt(_vm.filters.page - 1),
      "page-range": 1,
      "margin-pages": 1,
      "click-handler": _vm.paginateClick,
      "container-class": "pagination",
      "page-class": "page-item",
      "page-link-class": "page-link",
      "prev-class": "page-item",
      "prev-link-class": "page-link",
      "next-class": "page-item",
      "next-link-class": "page-link"
    }
  })], 1)]), _vm._v(" "), _c('full-table', {
    attrs: {
      "headerClass": "table-head",
      "filterClass": "table-filter table-subhead",
      "cols": _vm.cols,
      "data": _vm.tableData,
      "filterInputClass": "form-control",
      "filters": _vm.filters
    },
    on: {
      "filter": _vm.fetch
    },
    scopedSlots: {
      "account_name_heading": function(props) {
        return [_c('span', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.bottom",
            value: (_vm.metaUnique(_vm.meta.account_name)),
            expression: "metaUnique(meta.account_name)",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_vm._v("\n                " + _vm._s(props.value) + " "), _c('i', {
          staticClass: "fa fa-info-circle",
          staticStyle: {
            "font-size": "12px"
          }
        })])]
      },
      "carrier_name_heading": function(props) {
        return [_c('span', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.bottom",
            value: (_vm.metaUnique(_vm.meta.carrier_name)),
            expression: "metaUnique(meta.carrier_name)",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_vm._v("\n                " + _vm._s(props.value) + " "), _c('i', {
          staticClass: "fa fa-info-circle",
          staticStyle: {
            "font-size": "12px"
          }
        })])]
      },
      "net_billed_heading": function(props) {
        return [_c('span', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.bottom",
            value: (_vm.metaDollar(_vm.meta.net_billed)),
            expression: "metaDollar(meta.net_billed)",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_vm._v("\n                " + _vm._s(props.value) + " "), _c('i', {
          staticClass: "fa fa-info-circle",
          staticStyle: {
            "font-size": "12px"
          }
        })])]
      },
      "commission_heading": function(props) {
        return [_c('span', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip.bottom",
            value: (_vm.metaDollar(_vm.meta.commission)),
            expression: "metaDollar(meta.commission)",
            modifiers: {
              "bottom": true
            }
          }]
        }, [_vm._v("\n                " + _vm._s(props.value) + " "), _c('i', {
          staticClass: "fa fa-info-circle",
          staticStyle: {
            "font-size": "12px"
          }
        })])]
      },
      "date_posted_filter": function(props) {
        return [_c('timeframe', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.filters.search.date_posted),
            expression: "filters.search.date_posted"
          }],
          attrs: {
            "timeframes": _vm.timeframes,
            "groups": _vm.groups
          },
          domProps: {
            "value": (_vm.filters.search.date_posted)
          },
          on: {
            "input": function($event) {
              _vm.filters.search.date_posted = $event
            }
          }
        })]
      }
    }
  }, [_c('pulse-loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "color": "#5e9cd3"
    },
    slot: "loading"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-3"
  }, [_c('h2', [_vm._v("Cashflow")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5747d5fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cashflow/Cashflow.vue
// module id = 392
// module chunks = 0